import React, { useState } from 'react';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import { isMobileOnly, isTablet } from 'react-device-detect';
import Dialog from '@mui/material/Dialog';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { LazyImage } from '../../Components/Common/ImgLoading';
import { useSelector } from 'react-redux';
import { Translate } from '../../localization';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const myStyles = {
    fontSize: '18px',
    paddingBottom: '5px',
};

const Game = (props) => {
    const { game, playGame } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [openGameInfo, setOpenGameInfo] = useState(false);
    const userData = useSelector((state) => state.user.data);

    const handleClickOpen = () => {
        setOpenGameInfo(true);
    };

    const handleClickClose = () => {
        setOpenGameInfo(false);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const isLoggedIn = () => {
        return userData !== null;
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    let imgUrl
    try {
        imgUrl = game.images.find((img) => {
            return JSON.parse(img).type == 'banner';
        });
    } catch (e) {
        console.error('games error ', game)
    }

    const playCasinoGame = (game, type) => {
        if (!isLoggedIn()) {
            handleClickOpen();
        } else {
            playGame(game, type);
        }
    };

    return (
        <li key={game.game_name} id="casinoListDiv">
            <div className="game-card-wrap">
                <div className="hover-parent" style={{ flexDirection: 'column' }}>
                    <LazyImage image={imgUrl && JSON.parse(imgUrl)?.url} fallbackImage="/images/loading-dark.gif" className={`casino-img ${''}`} />
                    <div className={`play-btn ${''}`} style={{ flexDirection: 'column' }}>
                        <span className="icon-wrap" onClick={() => handleClickOpen()}>
                            <i className="far fa-play-circle ico non-hover-ico"></i>
                            <i className="fas fa-play-circle ico hover-ico"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div className="game-text-wrap d-flex justify-content-between ">
                <div className="game-text-left">
                    <h3 style={myStyles}>{game.game_name}</h3>
                    <p>{game.provider_name}</p>
                </div>
                <div className={`info-icon ${'mob-display'}`}>
                    <Button
                        aria-describedby={id}
                        variant="contained"
                        onClick={handleClick}
                    >
                        <img src="/images/info.png" />
                    </Button>
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                    >
                        <ul className="game-info">
                            <li>
                                <div>{Translate.Game_Name}</div>
                                <div>{game.game_name}</div>
                            </li>
                            <li>
                                <div>{Translate.Provider}</div>
                                <div>{game.provider_name}</div>
                            </li>
                            {game?.volatility_name && <li>
                                <div>{Translate.Volatility}</div>
                                <div>{game.volatility_name}</div>
                            </li>}
                            {game?.features && <li>
                                <div>{Translate.Features}</div>
                                <div>
                                    {game.features?.map((item, i) => {
                                        let data = JSON.parse(item);
                                        let comma = i == 0 ? '' : ', ';
                                        return comma + data.name;
                                    })}
                                </div>
                            </li>}
                            {game.themes && <li>
                                <div>{Translate.Themes}</div>
                                <div>
                                    {game.themes?.map((item, i) => {
                                        let data = JSON.parse(item);
                                        let comma = i == 0 ? '' : ', ';
                                        return comma + data.name;
                                    })}
                                </div>
                            </li>}
                        </ul>
                    </Popover>
                </div>
            </div>
            <Dialog
                fullScreen={false}
                open={openGameInfo}
                onClose={handleClickClose}
                TransitionComponent={Transition}
                className='game-information'
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            <img src="/images/sports/logo.png" width={50} height={50} alt='logo' />
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClickClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Divider />
                <List>
                    <ListItem >
                        <LazyImage image={imgUrl && JSON.parse(imgUrl)?.url} fallbackImage="/images/loading-dark.gif" className="w-100" />
                    </ListItem>
                    <Divider />
                    <ListItem >
                        <div className="game-text-left">
                            <h3 style={myStyles}>{game.game_name}</h3>
                            <h6>{game.provider_name}</h6>
                        </div>
                    </ListItem>
                    {isLoggedIn() 
                        ? 
                        <ListItem >
                            <button className='btn-gameinfo' onClick={() => { handleClickClose(); playGame(game, 'real'); }}>Play</button>
                        </ListItem>
                        :
                        <ListItem >
                            <button className='btn-gameinfo' onClick={() => { handleClickClose(); playGame(game, 'real'); }}>Log In To Play</button>
                        </ListItem>
                    }
                    <ListItem >
                        <ul className="game-info-mob">
                            <li>
                                <div>{Translate.Game_Name}</div>
                                <div>{game.game_name}</div>
                            </li>
                            <li>
                                <div>{Translate.Provider}</div>
                                <div>{game.provider_name}</div>
                            </li>
                            {game?.volatility_name && <li>
                                <div>{Translate.Volatility}</div>
                                <div>{game.volatility_name}</div>
                            </li>}
                            {game?.features && <li>
                                <div>{Translate.Features}</div>
                                <div>
                                    {game.features?.slice(0, 4).map((item, i) => {
                                        let data = JSON.parse(item);
                                        let comma = i == 0 ? '' : ', ';
                                        return comma + data.name;
                                    })}
                                </div>
                            </li>}
                            {game?.themes && <li>
                                <div>{Translate.Themes}</div>
                                <div>
                                    {game.themes?.slice(0, 4).map((item, i) => {
                                        let data = JSON.parse(item);
                                        let comma = i == 0 ? '' : ', ';
                                        return comma + data.name;
                                    })}
                                </div>
                            </li>}
                        </ul>
                    </ListItem>
                </List>
            </Dialog>
        </li >
    );
};

export default Game;
